import React from 'react';

import GrabArrowLeft from './grab-arrow-left.svg';
import GrabArrowRight from './grab-arrow-right.svg';
import { Component, Icon } from './styles';

export const GrabHandle = React.memo(
  React.forwardRef<HTMLDivElement>((props, ref) => {
    return (
      <Component ref={ref}>
        <Icon>
          <GrabArrowLeft />
        </Icon>
        <Icon>
          <GrabArrowRight />
        </Icon>
      </Component>
    );
  })
);
